import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Features', href: '/features' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'About', href: '/about' },
];

export function WebsiteNavbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="h-8 w-8 bg-[#6366F1] rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">B</span>
            </div>
            <span className="text-xl font-bold text-[#1E293B]">Brix<span className="text-[#6366F1]">Lead</span></span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map(link => (
              <Link
                key={link.href}
                to={link.href}
                className={`text-sm font-medium transition-colors ${
                  location.pathname === link.href
                    ? 'text-[#6366F1]'
                    : 'text-[#64748B] hover:text-[#1E293B]'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            <Link to="/login" className="text-sm font-medium text-[#64748B] hover:text-[#1E293B] transition-colors px-4 py-2">
              Login
            </Link>
            <Link to="/register" className="text-sm font-semibold text-white bg-[#6366F1] hover:bg-[#4F46E5] px-5 py-2.5 rounded-lg transition-colors">
              Get Started Free
            </Link>
          </div>

          {/* Mobile menu button */}
          <button onClick={() => setOpen(!open)} className="md:hidden p-2 text-[#64748B]">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <div className="md:hidden pb-4 border-t border-gray-100 pt-4">
            {NAV_LINKS.map(link => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setOpen(false)}
                className="block py-2 text-sm font-medium text-[#64748B] hover:text-[#6366F1]"
              >
                {link.label}
              </Link>
            ))}
            <div className="flex flex-col gap-2 mt-4">
              <Link to="/login" className="text-center text-sm font-medium text-[#64748B] border border-gray-200 rounded-lg py-2.5">Login</Link>
              <Link to="/register" className="text-center text-sm font-semibold text-white bg-[#6366F1] rounded-lg py-2.5">Get Started Free</Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
